import React from 'react'
import { Typography } from '@material-ui/core'
import { ModalConfirmacao } from 'components'

export const ModalRetirar = (props) => {
  const { aberto, onClose, onConfirm, processando, identificador } = props

  return (
    <ModalConfirmacao
      aberto={aberto}
      onClose={onClose}
      onConfirm={onConfirm}
      processando={processando}
      titulo="RETIRAR VESTÍGIO"
      confirmarLabel="Confirmar"
      maxWidth="sm"
    >
      <Typography variant="body1" style={{ marginTop: '10px' }}>
        O vestígio <strong>{identificador}</strong> ficará sob sua responsabilidade. Tem certeza que deseja realizar a retirada?
      </Typography>
    </ModalConfirmacao>
  )
}
